/*
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-03-07 16:52:53
 * @LastEditTime: 2019-03-11 15:27:44
 */
import request from "@/plugins/axios/request";
//通过id查询单独文章
//inMenu :菜单
//openNew :是否打开新窗口
//route :模板
export function findbytype(type) {
    return request({
        url: "/sysDict/findbytype",
        method: "post",
        data: type
    });
}
